import PropTypes from 'prop-types';
import { AiOutlineSearch } from 'react-icons/ai';
import { Button } from 'ypf-pas-general-ui-components';

import DateInputCalendar from '../Calendar/DateInputCalendar/DateInputCalendar';

import './PendAuthDateFilter.scss';

const PendAuthDateFilter = ({
  minDate,
  maxDate,
  handleStartDateChange,
  handleEndDateChange,
  arrayDate,
  isMSDS,
  handleSearch,
  startDate,
  endDate
}) => (
  <div className="d-flex flex-row gap-3 align-items-end date-filter" style={{ width: '450px' }}>
    <DateInputCalendar
      arrayDate={arrayDate}
      handleChangeDate={handleStartDateChange}
      isMSDS={isMSDS}
      label="Fecha desde"
      maxDate={endDate || maxDate}
      minDate={minDate}
      selectDay={startDate}
    />
    <DateInputCalendar
      arrayDate={arrayDate}
      handleChangeDate={handleEndDateChange}
      isMSDS={isMSDS}
      label="Fecha hasta"
      maxDate={maxDate}
      minDate={startDate || minDate}
      selectDay={endDate}
    />
    <Button
      className="search-button"
      icon={AiOutlineSearch}
      onClick={() => handleSearch()}
      type="button"
      widthButton="50px"
    />
  </div>
);

PendAuthDateFilter.propTypes = {
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  // selectDay: PropTypes.string,
  startDate: PropTypes.string,
  handleStartDateChange: PropTypes.func,
  handleEndDateChange: PropTypes.func,
  arrayDate: PropTypes.arrayOf(PropTypes.string),
  isMSDS: PropTypes.bool,
  endDate: PropTypes.string,
  handleSearch: PropTypes.func
};
PendAuthDateFilter.defaultProps = {
  minDate: '',
  maxDate: '',
  startDate: '',
  endDate: '',
  // selectDay: '',
  handleStartDateChange: () => {
    /* empty */
  },
  handleEndDateChange: () => {},
  arrayDate: [],
  isMSDS: false,
  handleSearch: () => {
    /* empty */
  }
};

export default PendAuthDateFilter;
